import SubcategoryPage from '@/components/template/SubcategoryPage';

const UilliStair = () => {
  const products = [
    {
      title: "Uilli Stair Standard",
      imageSrc: "https://images.unsplash.com/photo-1581539250439-c96689b516dd?auto=format&fit=crop&q=80",
      url: "/proizvodi/uilli-stair-standard"
    },
    {
      title: "Uilli Stair Deluxe",
      imageSrc: "https://images.unsplash.com/photo-1567016432779-094069958ea5?auto=format&fit=crop&q=80",
      url: "/proizvodi/uilli-stair-deluxe"
    },
    {
      title: "Uilli Stair Premium",
      imageSrc: "https://images.unsplash.com/photo-1551298370-9d3d53740c72?auto=format&fit=crop&q=80",
      url: "/proizvodi/uilli-stair-premium"
    }
  ];

  return (
    <SubcategoryPage
      title="Uilli Stair"
      description="Moderne stopnice Uilli Stair, ki dodajo eleganco in funkcionalnost vašemu domu."
      heroImage="https://images.unsplash.com/photo-1581539250439-c96689b516dd?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default UilliStair;